import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromActionTypes from './action-types.actions';
import { ActionTypesState } from './action-types.interfaces';
import { map } from 'rxjs/operators';
import { ActionType } from '@quorum/models/xs-resource';
@Injectable()
export class ActionTypesEffects {
  
  getActionTypesFromServer = createEffect(() => this.dataPersistence.fetch(fromActionTypes.GET_ACTION_TYPES_FROM_SERVER, {
    run: (action: fromActionTypes.GetActionTypesFromServer, state: any) => {
      if (state.svcDropdowns.actionTypes.ids.length == 0) {
        return this.apiService
          .get<ActionType[]>(`v/1/fixed-operations/action-types`, {
            params: action.payload
          })
          .pipe(
            map((actionTypes: ActionType[]) => {
              return new fromActionTypes.GetActionTypesFromServerSuccess({
                actionTypes: actionTypes
              });
            })
          );
      }
    },
    onError: (action: fromActionTypes.GetActionTypesFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ActionTypesState>,
    private apiService: ApiService
  ) {}
}
